import { type CSSProperties } from 'react';

export type DimensionSource = {
  measured?: { width?: number; height?: number };
  style?: Pick<CSSProperties, 'width' | 'height'>;
  width?: number;
  height?: number;
};

export type Dimensions = { width: number; height: number };

export function getNodeDimensions(node: DimensionSource): Dimensions {
  const width =
    node.measured?.width ?? (typeof node.style?.width === 'number' ? node.style.width : undefined) ?? node.width ?? 0;
  const height =
    node.measured?.height ??
    (typeof node.style?.height === 'number' ? node.style.height : undefined) ??
    node.height ??
    0;

  return { height, width };
}
